export default {
  hero: {
    "are-you-a-supplier": "Je suis un fournisseur ?",
    "new-material": "Nouveau matériel",
    title: "Acheter votre matériel n'a jamais été aussi simple",
    description:
      "Le meilleur outil des installateurs pour optimiser leurs achats et leur gestion d’entrepôt.",
    "try-now": "Essayer maintenant",
    "trusted-by": "Reconnu par",
  },
  values: {
    object: "Fonctionnalités",
    title: "Économiser +10 % sur vos coûts d’approvisionnement",
    description:
      "Quis tellus eget adipiscing convallis sit sit eget aliquet quis. Suspendisse eget egestas a elementum pulvinar et feugiat blandit at. In mi viverra elit nunc.",
    features: {
      quote: {
        title: "Demande de devis auprès des fournisseurs",
        description:
          "Envoyez en 1 clic vos listes de matériel directement à vos contacts chez vos fournisseurs pour accélerer vos demandes de devis.",
      },
      buying: {
        title: "Accès à des produits pour achat immédiat",
        description:
          "Explorez une sélection de produits disponibles à l'achat immédiat en ligne, sans attentes ni formalitérs, pour gagner du temps et de l'argent.",
      },
      delivery: {
        title: "Suivi des livraisons",
        description:
          "Gardez un œil en temps réel sur l'état de vos commandes et suivez chaque étape de la livraison jusqu'à la réception de votre matériel.",
      },
      references: {
        title: "10000+ références produits",
        description:
          "Choisissez vos modules, onduleurs, coffrets, batteries ... depuis notre base de données mise à jour en temps réel. Intégrée avec devis et démarches.",
      },
      integration: {
        title: "Intégration facile du matériel de vos chantiers",
        description:
          "Planification automatique des listes d'équipements pour vos installations photovoltaïques à partir de vos études et dossiers urbanisme.",
      },
      historic: {
        title: "Historique des commandes",
        description:
          "Accédez à un historique complet de vos commandes passées pour suivre vos achats et gérer vos stocks plus efficacement.",
      },
    },
  },
  reservations: {
    badgeText: "Achat groupé",
    title:
      "Achetez votre matériel photovoltaïque auprès de la centrale d'achat la plus compétitive du marché",
    description:
      "Bénéficiez de prix de gros et limiter vos frais de livraison, avec nos réductions avantageuses en rejoignant notre programme d'achat groupé. En regroupant les commandes, le processus d'achat est simple pour les fournisseurs et économique pour les acheteurs.",
    advantages: {
      title:
        "Voici pourquoi cette approche est avantageuse et comment elle fonctionne en trois étapes simples.",
      price: {
        title: "Prix 30 % moins chers",
        description:
          "L'achat groupé permet de réduire considérablement les coûts en négociant des tarifs préférentiels grâce à des commandes combinées.",
      },
      quality: {
        title: "Produits innovants de qualité",
        description:
          "Les fournisseurs privilégient les commandes groupées en proposant des produits de haute qualité à prix réduits.",
      },
      simplicity: {
        title: "Simplification de la logistique",
        description:
          "L'achat groupé optimise la gestion en centralisant les commandes. Moins de livraisons et des économies sur vos frais de port.",
      },
    },
  },
  checkout: {
    title: "Catalogue de +10000 modèles",
    "see-more": "Voir toute la sélection",
    database: "Base de donnée",
  },
  simplicity: {
    object: "Optimisation",
    title: "Intégration facile du matériel prévu dans vos chantiers",
    paragraph1:
      "Notre solution facilite l'intégration du matériel prévu dans vos chantiers dès la phase de planification. Vous pouvez attribuer le matériel à différents chantiers ou devis de vos clients même avant sa réception.",
    paragraph2:
      "Grâce à notre interface intuitive, vous gérez facilement l'affectation du matériel aux chantiers en cours, ce qui simplifie la préparation et l'organisation de vos chantiers.",
    paragraph3:
      "Cette flexibilité permet une meilleure gestion des ressources et une planification plus efficace, tout en assurant que chaque chantier dispose des équipements nécessaires dès que les besoins sont définis.",
    "try-now": "Essayez maintenant",
  },
  logistics: {
    object: "Livraison",
    title: "Suivi de vos livraisons en temps réel",
    description:
      "Notre service de suivi vous permet de surveiller vos livraisons de matériel photovoltaïque en temps réel. Grâce à notre système de traçabilité avancé, vous recevez des mises à jour instantanées sur l'état de votre commande, depuis l'expédition jusqu'à la livraison finale. Vous pouvez consulter l'emplacement actuel de votre matériel, prévoir les délais de réception, et être informé de toute éventuelle modification ou retard. Ce suivi transparent et précis vous offre une tranquillité d'esprit, vous permettant de mieux planifier l'installation de vos équipements photovoltaïques et d’assurer une gestion efficace de votre chantier.",
    timeline: {
      step1: "Préparation et emballage du matériel pour l'expédition.",
      step2: "Expédition du matériel par l'expéditeur.",
      step3: "Transport du matériel vers le centre de distribution.",
      step4: "Traitement du matériel au centre de distribution.",
      step5: "Livraison du matériel à l'adresse de destination.",
      step6: "Confirmation de réception.",
    },
  },
  "data-driven": {
    "down-stream-sales-title": "Piloté par les données",
    "down-stream-sales-desc":
      "Nous serons la première place de marché à exploiter des informations basées sur les données pour faciliter les ventes de matériel. Notre plateforme héberge déjà une vaste base de données de matériel solaire avec plus de 10 000 produits. En utilisant des données sur les quantités de matériel en temps réel provenant de notre réseau d'installateurs - nos clients saisissent quotidiennement des modèles et des quantités précis lorsqu'ils utilisent les solutions projetsolaire - nous visons à optimiser en temps réel l'alignement de l'offre de matériel avec la demande.",
    "coming-soon": "Bientôt disponible",
    "purchase-suggestion-title": "Suggestions d'achat",
    "purchase-suggestion-desc":
      "Notre place de marché sera l'une des premières plateformes de e-commerce multi-fournisseurs en France, à l'instar de ce que SolarTraders ou Solar Clarity ont introduit avec succès sur d'autres marchés européens. Nous avons déjà obtenu une vaste gamme de listes de produits pour panneaux solaires, onduleurs, batteries et plus encore (plus que toute autre boutique en ligne en France), grâce à un partenariat avec un fournisseur basé à Rotterdam.",
    "human-in-loop-title": "Humain dans la boucle",
    "human-in-loop-desc":
      "Nous garderons l'humain dans la boucle, en mettant l'accent sur le rôle de conseil des représentants commerciaux en matériel et en aidant les équipes de vente de matériel à augmenter leurs revenus via notre plateforme. Notre mission est de réduire le coût de l'énergie solaire - tout en favorisant l'innovation numérique en France. Nous espérons pouvoir réduire les coûts de vente et de commercialisation - en minimisant les frictions pour promouvoir les meilleures offres directement auprès de nos milliers d’installateurs et développeurs.",
    "data-driven": "Piloté par les données",
    "sales-2024": "Ventes en 2024",
  },

  shop: {
    "secondary-menubar": {
      "lithium-ion-batteries": "Batteries lithium-ion",
      accessories: "Accessoires",
    },
    banner: {
      "promotion-messages": {
        "fast-delivery": "Livraison rapide sur les produits listés",
        "secure-payments":
          "Paiements en ligne sécurisés pour tous les fournisseurs",
        "new-products":
          "Nouveaux produits ajoutés chaque semaine - Découvrez-les !",
      },
      links: {
        about: "À propos de nous",
        blog: "Blog",
        help: "FAQ",
        support: "Assistance",
      },
    },
    home: {
      "collaboration-features": {
        title: "Une manière plus intelligente pour",
        description:
          "Que vous fournissiez des composants solaires ou que vous les installiez, nos outils vous permettent d'accomplir vos tâches quotidiennes plus rapidement et plus efficacement.",
        installers: "installateurs",
        suppliers: "fournisseurs",
        and: "et",
        "work-together": "de travailler ensemble",
        tab: {
          installers: "Installateurs",
          suppliers: "Fournisseur",
        },
        list: {
          "join-group-purchases": {
            title: "Rejoindre les achats groupés",
            description:
              "Regroupez vos commandes avec celles d'autres installateurs pour bénéficier de meilleurs tarifs sur les conteneurs et les volumes.",
          },
          "inventory-management": {
            title: "Gestion des stocks",
            description:
              "Suivez en temps réel vos stocks disponibles, leurs emplacements et les mouvements dans vos entrepôts.",
          },
          "organize-warehouse": {
            title: "Organisez votre entrepôt",
            description:
              "Accédez à l'espace d'entreposage, surveillez les livraisons et planifiez efficacement les installations.",
          },
          "request-quotes": {
            title: "Demandez facilement des devis",
            description:
              "Envoyez des demandes de devis individuelles ou groupées aux fournisseurs et obtenez les meilleures offres sur les composants.",
          },
          "track-orders-deliveries": {
            title: "Suivi des commandes & des livraisons",
            description:
              "Suivez chaque commande, de l'approbation du devis à la livraison, grâce à des mises à jour en temps réel.",
          },
          "manage-quote-requests": {
            title: "Gérer les demandes de devis",
            description:
              "Consultez, répondez et approuvez les demandes de devis d'installateurs depuis un tableau de bord centralisé.",
          },
          "manage-group-requests": {
            title: "Gérer les demandes de groupe",
            description:
              "Consultez les demandes d'achat groupé pour les prix en vrac ou par conteneur et répondez-y.",
          },
          "showcase-products": {
            title: "Mettez en valeur vos produits",
            description:
              "Répertoriez vos composants photovoltaïques disponibles, mettez à jour vos prix et mettez en évidence les détails de vos produits.",
          },
          "handle-orders": {
            title: "Gérez les commandes en toute simplicité",
            description:
              "Traitez les commandes confirmées et organisez efficacement les expéditions via votre espace de travail.",
          },
          "monitor-performance": {
            title: "Surveillez vos performances",
            description:
              "Obtenez des informations précieuses sur vos devis, vos conversions et vos produits les plus vendus grâce à des analyses intelligentes.",
          },
        },
      },
      premium: {
        title: "Améliorez votre flux de travail avec les modules",
        "premium-modules": "premium",
        description:
          "N'activez les outils avancés que lorsque vous en avez besoin : flexibles, modulaires et conçus pour les professionnels.",
        monthly: "Mensuel",
        yearly: "Annuellement",
        month: "mois",
        "integrated-design": {
          title: "Conception 3D intégrée",
        },
        "administrative-assistance": {
          title: "Assistance administrative",
        },
        "sales-accelerator-pro": {
          title: "Accélérateur de ventes Pro",
        },
        features: {
          design: {
            "generate-3d-project-models-description":
              "Générez vos calepinages en 3D",
            "unlimited-number-of-dimensions":
              "Nombre illimité de dimensionnements",
            "sales-support": "Aide à la vente",
          },
          administration: {
            "document-automation": "Automatisations des documents",
            "statistics-and-data-step-by-step":
              "Statistiques et données étape par étape",
            "smart-reminders-for-deadlines":
              "Rappels intelligents pour les dates limites",
          },
          "premium-sales": {
            "receive-call-requests-from-the-directory":
              "Recevez des demandes d’appels depuis l’annuaire",
            "appointments-added-to-your-calendar":
              "Obtenez des RDV prêt pour R2 sur votre agenda",
            "priority-placement": "Placement prioritaire",
          },
        },
        descriptions: {
          design:
            "Faites vos dimensionnements avancés en 3D vous-même grâce à Aurora Solar.",
          administration:
            "Gérez tout le flux des tâches de vos démarches administratives vous-même.",
          "premium-sales":
            "Figurez sur l'annuaire de confiance pour bénéficier de notre référencement.",
        },
        "billing-invoicing-pro": "Facturation et facturation Pro",
        "hardware-management": "Gestion du matériel",
        "coming-soon": "À venir bientôt",
        save: "Économisez",
        "upgrade-now": "Mettez à niveau maintenant",
        "what-you-get": "Ce que vous obtenez",
        questions: "Des questions ? Consultez notre page d’aide",
        "contact-us":
          "Les installateurs près de chez vous sont en pleine croissance, rejoignez-les avant qu’il soit trop tard.",
      },
    },
  },
  subscription: {
    "order-details": {
      title: "Détails de la commande",
      currency: "Devise",
      plan: "Plan",
      price: "Prix",
      total: "Totale",
      month: "mois",
    },
    title: "Abonnement",
    "payment-information": {
      "select-payment-method": "Sélectionnez le mode de paiement",
      "add-new-payment-method": "Ajouter un nouveau mode de paiement",
      "card-number": "Numéro de carte",
      "expiration-date": "Expiration",
      "pay-now": "Soumettre le paiement",
      "country-region": "Pays/Région",
      address: "Votre adresse",
      city: "Ville",
    },
  },
  footer: {
    newsletter: {
      title: "Abonnez-vous à notre newsletter",
      subtitle:
        "Abonnez-vous à notre newsletter pour rester informé de toutes nos actus et mises à jour. ",
      placeholder: "Entrez votre adresse e-mail",
      button: "S'abonner",
    },
    company: {
      name: "L'Entrepôt",
      by: "Par",
      poweredBy: "projetsolaire",
    },
    contact: {
      phone: "+33 7 44 09 61 13",
      hours: "Lun - Ven 09:00 - 17:00 CET",
      rates: "Prix d'appel selon les tarifs de l'opérateur.",
    },
    sections: {
      contact: "Contact",
      categories: "Catégories",
      brands: "Marques",
    },
    links: {
      help: "Aide",
      startSelling: "Commencer à vendre",
      aboutUs: "À propos de nous",
      blog: "Blog",
    },
    categories: {
      solarPanels: "Panneaux solaires",
      inverters: "Onduleurs",
      energyStorage: "Stockage d'énergie",
      mountingSystems: "Systèmes de montage",
      electroTechnical: "Matériel électrique",
      eMobility: "E-mobilité",
    },
    legal: {
      disclaimer: "Déclaration légale",
      privacyPolicy: "Politique de confidentialité",
      termsAndConditions: "Conditions d'utilisation",
    },
  },
}
